export const cards = [
  {
    name: 'Waterfront Hotel',
    location: 'Balitmore, MD',
    date: '2026-03-14T21:30:00',
    link: 'https://maps.app.goo.gl/4P2Bvgi5fREt5PSE8',
    id: 1,
  },  
  {
    name: 'Waterfront Hotel',
    location: 'Balitmore, MD',
    date: '2026-04-11T21:30:00',
    link: 'https://maps.app.goo.gl/4P2Bvgi5fREt5PSE8',
    id: 2,
  },
  {
    name: 'Chauser Derby Part',
    location: 'Baltimore, MD',
    date: '2026-05-02T19:00:00',
    id: 3,
  },
  {
    name: 'Waterfront Hotel',
    location: 'Balitmore, MD',
    date: '2026-05-22T21:30:00',
    link: 'https://maps.app.goo.gl/4P2Bvgi5fREt5PSE8',
    id: 4,
  },
  {
    name: 'Waterfront Hotel',
    location: 'Balitmore, MD',
    date: '2026-06-20T21:30:00',
    link: 'https://maps.app.goo.gl/4P2Bvgi5fREt5PSE8',
    id: 5,
  }, 
];
